import React, { useState, useEffect } from 'react';
import Modal from 'react-awesome-modal';
import { useSelector, useDispatch } from 'react-redux';
import StarRatings from 'react-star-ratings';
import '@fortawesome/fontawesome-free/css/all.css';
import { useWindowDimensions } from '../../utils';
import { AddItemReview } from '../../store/actions';
import { API, STAR } from '../../constants';

function DialogProductReview({ open, closeDialog, product }) {
  const wording = useSelector(({ language }) => language.wording);
  const dispatch = useDispatch();

  const { width } = useWindowDimensions();

  const initialValues = {
    rating: 5,
    review: '',
    picture: null
  };
  const [values, setValues] = useState(initialValues);
  const [error, setError] = useState();

  useEffect(() => {
    setValues((values) => ({
      ...values,
      product
    }));
  }, [product]);

  const changeRating = (newRating, name) => {
    setError();
    setValues((values) => ({
      ...values,
      [name]: newRating
    }));
  };

  const handleCloseDialog = (e) => {
    setError();
    e.preventDefault();
    setValues(initialValues);
    closeDialog();
  };

  const handleUpload = async (e) => {
    let file = e.target.files;
    let name = e.target.name;
    let files = [];

    setError();
    e.persist();
    if (file.length > 0) {
      if (file.length <= 5) {
        for (let i = 0; i < 5; i++) {
          if (file[i]) {
            files.push(file[i]);
          }
        }

        setValues((values) => ({
          ...values,
          [name]: files
        }));
      } else {
        setValues((values) => ({
          ...values,
          [name]: null
        }));
        setError('limitFilesAmount');
      }
    } else {
      setValues((values) => ({
        ...values,
        [name]: null
      }));
    }
  };

  const handleFieldChange = (e) => {
    let { name, type, value, checked } = e.target;

    setError();
    e.persist();
    e.preventDefault();

    setValues((values) => ({
      ...values,
      [name]: type === 'checkbox' ? checked : value
    }));
  };

  // const handleClickSuggestButton = (value) => {
  //   setValues((values) => ({
  //     ...values,
  //     review: values.review ? values.review + '\n' + value : value
  //   }));
  // };

  const handleSubmit = () => {
    dispatch(AddItemReview(values));
  };

  const renderImages = () => {
    let img = [];

    if (values.picture && values.picture.length > 0) {
      for (let i = 1; i <= values.picture.length - 1; i++) {
        img.push(
          <div
            key={'img_' + i}
            style={{
              width: width > 600 ? 80 : width > 480 ? 45 : 45,
              height: width > 600 ? 80 : width > 480 ? 45 : 45,
              marginRight: width > 600 ? 10 : width > 480 ? 4.5 : 4.5,
              backgroundImage: `url(${URL.createObjectURL(values.picture[i])})`,
              backgroundSize: 200,
              backgroundRepeat: 'no-repeat',
              backgroundPositionX: '50%',
              backgroundPositionY: '50%',
              marginBottom: 10
            }}
          />
        );
      }
    }

    return img;
  };

  return (
    <Modal
      visible={open}
      width={width > 600 ? '600' : width > 480 ? '400' : '300'}
      effect="fadeInUp"
      onClickAway={handleCloseDialog}>
        { open &&
          <div style={{ margin: 20 }}>
            <div className="dialog-header">
              <h4 style={{ color: '#2d64cf' }}>
                {wording.dialogProductReview.productRating}
              </h4>
            </div>

            <div
              className="dialog-body mt-10 mb-10"
              style={{
                display: 'flex',
                flexDirection: 'row',
                justifyContent: 'flex-start',
                alignItems: 'center',
                color: 'blue'
              }}>
              <img
                src={
                  API.PRODUCT_IMG_URL + (values.product && values.product.picture)
                }
                style={{ marginRight: 10, width: 60, height: 60, borderRadius: 30 }}
                alt="product"
              />
              {values.product && values.product.productName}
            </div>

            <div
              className="dialog-body mt-10 mb-10"
              style={{
                display: 'flex',
                flexDirection: 'column',
                justifyContent: 'center',
                alignItems: 'center',
                color: 'blue'
              }}>
              <StarRatings
                name="rating"
                rating={values.rating}
                starDimension={width > 480 ? '35' : '30'}
                numberOfStars={STAR.NUMBER_OF_STAR}
                starRatedColor={STAR.RATED_COLOR}
                starEmptyColor={STAR.EMPTY_COLOR}
                starSpacing={STAR.SPACING}
                svgIconPath={STAR.svgIconPath}
                changeRating={changeRating}
              />
              {wording.dialogProductReview.rating[values.rating]}
            </div>

            <div
              className="dialog-body mt-10 mb-10"
              style={{
                display: 'flex',
                flexDirection: 'row',
                flexWrap: 'wrap',
                justifyContent: 'flex-start',
                alignItems: 'center'
              }}>
              <textarea
                className="form-control"
                name="review"
                rows="3"
                placeholder={wording.dialogProductReview.placeholder}
                onChange={handleFieldChange}
                value={values.review}></textarea>

              <div
                style={{
                  display: 'flex',
                  flexDirection: 'column',
                  color: '#000',
                  justifyContent: 'center',
                  alignItems: 'center'
                }}>
                <input
                  accept="image/jpeg"
                  style={{ display: 'none' }}
                  id="picture"
                  name="picture"
                  type="file"
                  onChange={handleUpload}
                  multiple="multiple"
                />
                <label htmlFor={'picture'}>
                  <div
                    className="btn btn-md btn-light"
                    style={{
                      marginBottom: 5,
                      width: width > 600 ? 80 : width > 480 ? 45 : 45,
                      height: width > 600 ? 80 : width > 480 ? 45 : 45,
                      fontSize: width > 600 ? 14 : width > 480 ? 10 : 10,
                      color: '#ccc',
                      borderRadius: 4,
                      display: 'flex',
                      flexDirection: 'column',
                      justifyContent: 'center',
                      alignItems: 'center',
                      backgroundColor: 'transparent',
                      borderWidth: 1,
                      borderStyle: 'dashed',
                      borderColor: '#ccc',
                      backgroundImage:
                        values.picture &&
                        values.picture.length > 0 &&
                        `url(${URL.createObjectURL(values.picture[0])})`,
                      backgroundSize: 200,
                      backgroundRepeat: 'no-repeat',
                      backgroundPositionX: '50%',
                      backgroundPositionY: '50%'
                    }}>
                    <i className="fa fa-camera fa-2x" />
                    {values.picture && values.picture.length
                      ? values.picture.length
                      : 0}
                    /5
                    {/* {wording.dialogProductReview.buttonUploadPicture} */}
                    {/* <br />
                    {wording.dialogProductReview.maxFiles} */}
                  </div>
                </label>
              </div>

              <div
                style={{
                  color: 'red',
                  display: 'flex',
                  flexDirection: 'row',
                  flexWrap: 'wrap',
                  justifyContent: 'flex-start',
                  marginLeft: 10
                }}>
                {values.picture && values.picture.length > 0 && renderImages()}
                {error === 'limitFilesAmount' &&
                  wording.dialogProductReview.warningMaxFiles}
              </div>
            </div>

            <div
              className="dialog-body mt-20 mb-20"
              style={{
                display: 'flex',
                flexDirection: 'row',
                flexWrap: 'wrap',
                justifyContent: 'flex-end',
                alignItems: 'center'
              }}>
              <button
                className="btn btn-md btn-light"
                style={{
                  marginLeft: 5,
                  marginBottom: 5
                }}
                onClick={handleCloseDialog}>
                {wording.dialogProductReview.buttonCancel}
              </button>
              <button
                className="btn btn-lg btn-blue"
                style={{
                  marginLeft: 5,
                  marginBottom: 5
                }}
                onClick={handleSubmit}>
                {wording.dialogProductReview.buttonConfirm}
              </button>
            </div>
          </div>
      }
    </Modal>
  );
}

export default DialogProductReview;
